import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { ambiguityStatementsQuery } from '@/features/ambiguities/queries';
import { AmbiguitiesPage } from '@/features/ambiguities/components/ambiguities-page';
import { workspaceQuery } from '@/features/workspaces/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/',
)({
  staticData: { chatSurface: 'ambiguity' },
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    return context.queryClient.query({
      ...ambiguityStatementsQuery(workspace.type, params.workspaceId),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const { workspaceId, projectId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Ambiguities', nb: 'Uklare formuleringer' })}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <AmbiguitiesPage />
    </>
  );
}
